import { useIntl } from 'react-intl'
import { TextField, Typography } from 'src/modules/core/components'
import { formatBrandingMessage } from '../booking-branding-card.domain'
import type { BrandingNameFieldProps } from './branding-name-field.interface'
import classes from './branding-name-field.module.scss'

const LABEL_ID = 'booking-branding-name-label'
const HINT_ID = 'booking-branding-name-hint'
const ERROR_ID = 'booking-branding-name-error'

export function BrandingNameField({ value, placeholder, error, disabled, onChange }: BrandingNameFieldProps) {
  const { formatMessage } = useIntl()

  return (
    <div className={classes.root}>
      <Typography variant="body" className={classes.label} id={LABEL_ID}>
        {formatMessage({ id: 'settings.bookingBranding.name.label' })}
      </Typography>
      <TextField
        value={value}
        placeholder={placeholder || formatMessage({ id: 'settings.bookingBranding.name.placeholder' })}
        aria-labelledby={LABEL_ID}
        aria-describedby={error ? `${HINT_ID} ${ERROR_ID}` : HINT_ID}
        aria-invalid={!!error}
        hint={formatMessage({ id: 'settings.bookingBranding.name.hint' })}
        hintId={HINT_ID}
        error={error ? formatBrandingMessage(error, formatMessage) : undefined}
        errorId={ERROR_ID}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
